import React, { useEffect, useRef } from "react";
import "./TablePendingProposals.css";

const TablePendingProposals = ({
  data,
  isAuthorized,
  getStatusDisplay,
  onApprove,
  onReject,
  onDownload = () => {}
}) => {
  const rowsRef = useRef([]);

  

  return (
    <table className="tabela tabela-historico">
      <thead>
        <tr>
          <th>Project</th>
          <th>Customer</th>
          <th>Status</th>
          <th>Date</th>
          <th>Submitted by</th>
          <th className="acao-celula">Actions</th>
        </tr>
      </thead>

      <tbody>
        {data.map((row, index) => (
          <tr key={index} ref={(el) => (rowsRef.current[index] = el)}>
            <td>{row.projectName}</td>
            <td>{row.customerName}</td>

            <td>
              {(() => {
                const statusUI = getStatusDisplay(row);
                return (
                  <>
                    <span className={statusUI.className}>
                      {statusUI.label}
                    </span>
                    {statusUI.description && (
                      <small className="status-reason">
                        <i className="fa fa-info-circle"></i> {statusUI.description}
                      </small>
                    )}
                  </>
                );
              })()}
            </td>

            <td>{new Date(row.sentAt).toLocaleDateString()}</td>
            <td>{row.submittedBy}</td>

            <td className="acao-celula">
              <button
                className={`tabela-download ${row.status === "pending" ? "btn-disable" : ""
                  }`}
                disabled={row.status === "pending"}
                title={
                  row.status === "pending"
                    ? "PDF locked until approval"
                    : "Download PDF"
                }
                onClick={() => {
                  if (typeof onDownload === "function") {
                    onDownload(row);
                  }
                }}
              >
                <i className="fa-solid fa-download"></i>
              </button>



              {isAuthorized && row.status === "pending" && (
                <>
                  <button className="tabela-aprovar" onClick={() => onApprove(row)}>
                    <i className="fa-solid fa-check"></i>
                  </button>
                  <button className="tabela-reprovar" onClick={() => onReject(row)}>
                    <i className="fa-solid fa-xmark"></i>
                  </button>
                </>
              )}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default TablePendingProposals;
